const makeHtml = (contents,title,image) => [
  '<div class="info-contents">',
  image && `  <figure class="image"><img src="${image}" /></figure>`,
  `  <div class="container">`,
  title && `    <div class="subtitle is-4">${title}</div>`,
  ...contents.map(d => `    <div>${d}</div>`),
  '  </div>',
  '</div>',
].filter(d=>d).join('\n')


export default [
  { name: 'smallGenerators',
    html: makeHtml([
'発電棟の装置とは別に、大型大気レーダー（PANSYレーダー）観測専用に150kVAのディーゼル発電装置2基が設置されています。',
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/20201226pansy.html" target="_blank">こちらのリンク</a>から御覧ください',
    ], '小型発電機小屋', './data/hotspot/36d2ac4c-0966-11ec-8e14-063b2b63adb9-1/plane'),
  },
  { name: 'observer',
    html: makeHtml([
'現在昭和基地を支えている第62次越冬隊員。海との境目は分かりづらいですが、陸地に立っています。隊員はみな安全講習を受けており、海氷上へ単独で出ることはありません。',
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/20210318post-142.html" target="_blank">こちらのリンク</a>から御覧ください',
    ], '観測隊員'),
  },
  { name: 'environmental',
    html: makeHtml([
'環境科学棟の土台です。建物の老朽化のため、第62次隊が夏期間に解体しました。残された土台も第63次隊が夏期間に解体する予定です。',
'Twitterの関連記事はこちらから<a href="https://twitter.com/kyokuchiken/status/1346016358828396545" target="_blank">こちらのリンク</a>から御覧ください',
    ], '環境科学棟土台', './data/hotspot/364fc458-0966-11ec-8e14-063b2b63adb9-1/plane')
  },
  { name: 'observationWarehouse',
    html: makeHtml([
      '観測倉庫の跡地です。建物の老朽化のため、第62次隊が夏期間に解体しました。スノードリフトが付きやすい立地だったため、解体まで観測隊は除雪に苦労してきました。',
    ], '観測倉庫跡地', './data/hotspot/374da65e-0966-11ec-8e14-063b2b63adb9-1/plane')
  },
  { name: 'redome',
    html: makeHtml([
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/20210225vlbi-1.html" target="_blank">こちらのリンク</a>から御覧ください',
    ], '多目的衛星受信アンテナ', './data/hotspot/36899d7c-0966-11ec-8e14-063b2b63adb9-1/plane'),
  },
  { name: 'intelSatRedome',
    html: makeHtml([
'大型の衛星通信アンテナが設置されているレドームです。昭和基地はこのアンテナを介してネットワーク接続を行っています。強力な電波を発する設備のため、基地中心部から離れた場所に設置されています。',
    ], 'インテルサットアンテナレドーム'),
  },
  { name: 'freshAir',
    html: makeHtml([
'その名の通り清浄な大気を観測するため、生活や業務の影響を受けないように基地中心部やその他建築物から離れた場所に位置しています。通称ゾル小屋。',
    ], '清浄大気観測小屋', './data/hotspot/36fe0504-0966-11ec-8e14-063b2b63adb9-1/plane'),
  },
  { name: 'firewall',
    html: makeHtml([
      '昭和基地の中心、管理棟エリアへの主要な入口の一つです。',
    ],'防火区画C'),
  },
  { name: 'oldCentral',
    html: makeHtml([
      '1957年に南極地域観測隊第1次隊で建設されたものが現存しております。',
      '※下記ブログ内では1959年と記載していますが、そちらは誤りです。',
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/201902172019217160-913b.html" target="_blank">こちらのリンク</a>から御覧ください',
    ],'旧主屋棟'),
  },
  { name: 'mainObservatory',
    html: makeHtml([
  '既に解体された気象棟や環境科学棟をはじめとする各建物の機能を集約した昭和基地での観測の中心地です。',
    ], './data/hotspot/298f4248-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: '19',
    html: makeHtml([
      '昭和基地といえばここ！１度は写真で見たことのある方も多いのではないでしょうか。基地周辺では珍しい平坦な地形のため、各種行事に利用しています。',
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/20210118post-125.html" target="_blank">こちらのリンク</a>から御覧ください',
    ], '19広場', './data/hotspot/29cf7836-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'sewage',
    html: makeHtml([
      '昭和基地で生じる汚水処理を行っている建物です。海氷近くに位置しているため、ゾンデ棒等の海氷上に出るために必要な装備置き場にもなっています。隊員間では旧作業工作棟と呼ばれることも多いです。',
    ], '汚水処理棟', './data/hotspot/2acf5c2e-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'kerun',
    html: makeHtml([
    '1960年10月に、第4次南極地域観測隊で越冬中に遭難し亡くなられた、故福島紳隊員の死を悼むために建てられた慰霊碑です。1972年の南極条約協議国会議（ATCM）にて、南極史跡記念物に指定されています。',
'観測隊ブログの関連記事は<a href="https://nipr-blog.nipr.ac.jp/jare/20210201post-133.html" target="_blank">こちらのリンク</a>から御覧ください',
    ], '福島ケルン', './data/hotspot/2a1b7592-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'keunZoom1',
    html: makeHtml([
      '看板の拡大写真です。',
    ],null, './data/hotspot/2a03e65c-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'keunZoom2',
    html: makeHtml([
      '看板の拡大写真です。',
    ],null, './data/hotspot/2a386ec2-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: '100l',
    html: makeHtml([
      '基地生活を支える大切な貯水槽です。雪に埋もれてしまっていますが、機能に問題はありません。',
'Twitterの関連記事はこちらから<a href="https://twitter.com/kyokuchiken/status/1348917641407201283" target="_blank">こちらのリンク</a>から御覧ください',
    ], '100kℓ水槽', './data/hotspot/2a9e7ece-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: '130l',
    html: makeHtml([
'基地生活を支える大切な貯水槽です。生活用水が不足しないよう雪を投入することも日々の重要な仕事です。',
'Twitterの関連記事はこちらから<a href="https://twitter.com/kyokuchiken/status/1349642414089142272" target="_blank">こちらのリンク</a>から御覧ください',
    ], '130kℓ水槽', './data/hotspot/2a5587f0-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'food',
    html: makeHtml([
      '食糧等の倉庫機能の他、事務室やトレーニング器具の設置もされています。２階入口は昭和基地の中心、管理棟エリアへの主要な入口の一つです。',
      '写真は食料搬入時の様子です。',
    ], '倉庫棟', './data/hotspot/29b7f148-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'cycle',
    html: makeHtml([
      '昭和基地は岩盤が固く、道路を整備することが難しいためオフロード仕様です。遠い建物への移動に大変重宝します。写真はAヘリポートにて撮影。',
      '昭和基地全体のMAPは以下のリンクから<a href="https://www.nipr.ac.jp/antarctic/jarestations/" target="_blank">https://www.nipr.ac.jp/antarctic/jarestations/</a>',
    ], '自転車', './data/hotspot/29e9ed74-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'natural',
    html: makeHtml([
      '雪上車などの車両整備スペースの他、風力発電機の制御・蓄電設備、木工所、工作室などがある設営隊員の作業の中心地です。「2011年度グッドデザイン賞」を受賞しています。',
    ], '自然エネルギー棟', './data/hotspot/2a84e55e-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
  { name: 'generator',
    html: makeHtml([
    '基地の電力を賄う300kVAディーゼル発電装置が2基設置されている他、トイレや入浴設備等も備えている昭和基地の心臓部です。',
    ], '発電棟', './data/hotspot/2b1db928-0966-11ec-8539-06d61ac6b8d1-1/plane'),
  },
//    './data/
]
